export class Riser {
  public constructor(init?: Partial<Riser>) {
    Object.assign(this, init);
  }

  id: string;
  tubularStringId: string;
  includeRiser: boolean;
  riser: RiserModel;
}

export class RiserModel {
  outsideDiameter: number;
  insideDiameter: number;
  attachedTubularId: string;
}